import React, { useEffect, useState } from 'react'
import Modal from '@/Components/Modal/Modal'
import { createProjectBaseline, ProjectBaseline } from '@/Services/ProjectBaselineService'

type Props = { show: boolean; projectId: string; taskCount: number; onHide: () => void; onCreated: (baseline: ProjectBaseline) => void }

const BaseLineCreator = ({ show, projectId, taskCount, onHide, onCreated }: Props) => {
  const [name, setName] = useState('')
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => { if (show) { setName(''); setError('') } }, [show])

  const create = async () => {
    if (!name.trim() || saving) return
    setSaving(true); setError('')
    try { onCreated(await createProjectBaseline(projectId, name.trim())) }
    catch (error) {
      const requestError = error as { response?: { data?: { error?: string } } }
      setError(requestError.response?.data?.error || 'No se pudo crear la linea base')
    }
    finally { setSaving(false) }
  }

  const footer = <><button className="btn btn-secondary" onClick={onHide} disabled={saving}>Cancelar</button><button className="btn btn-primary" onClick={create} disabled={!name.trim() || saving}>{saving ? 'Creando...' : 'Crear linea base'}</button></>

  return <Modal show={show} title="Crear linea base" onClose={onHide} showCloseButton zIndex="2" footer={footer}>
    <div className="form-group"><label>Nombre</label><input className="form-control" value={name} onChange={e => setName(e.target.value)} autoFocus /></div>
    <div className="text-muted mb-3">Origen: Programacion actual. Se capturaran {taskCount} tareas.</div>
    {error && <div className="alert alert-danger mb-0">{error}</div>}
  </Modal>
}

export default BaseLineCreator
